<template>
  <div>
    <div class="header">
      <PrescriptionHeader
        :mobileTitle="$t('dispensing.delivery')"
        :isSecondaryText="isSecondaryText"
      />
    </div>
    <ExceptionAlerts v-if="!showExeptionAlerts" />
    <DispensingForm />
  </div>
</template>

<script>  
  import PrescriptionHeader from "@/components/general/PrescriptionHeader.vue";
  import DispensingForm from "@/components/dispensing/DispensingForm.vue";
  import ExceptionAlerts from "@/components/dispensing/ExceptionAlerts.vue";
  import { config } from '@/plugins/env.config'
  import { v4 as uuidv4 } from 'uuid';

  import { createNamespacedHelpers } from 'vuex'
  const prescriptionModule = createNamespacedHelpers('prescription');

  export default {
    data: () => ({
      isSecondaryText: true,
      showExeptionAlerts: false,
    }),
    methods: {
      ...prescriptionModule.mapActions(['createDeliveryInitializationEvent', 'setTransactionId']),
    },
    components: {
      PrescriptionHeader,
      DispensingForm,
      ExceptionAlerts,
    },
    mounted () {
      this.showExeptionAlerts = this.providers.length && this.products.length;
      if(config.flagSendLogsTrackingApi){
        const transactionId = uuidv4();
        this.setTransactionId(transactionId);
        this.createDeliveryInitializationEvent();
      }
    },
    computed: {
      ...prescriptionModule.mapGetters(['providers', 'products'])
    },
  }
</script>

<style lang="scss" scoped>
  .header {
    background-color: #f9f9f9 !important;
  }
</style>
